import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AddressType, DefaultGUID, EnabledCountryCodes } from 'src/app/@shared/constants/Constant';
import { ICountryList } from 'src/app/model/Country.model';
import { LocationService } from 'src/app/service/location.service';
import { MemberService } from 'src/app/service/member.service';
import { CreateLocation, ICreateLocationResponseModel } from 'src/app/service/service-request';
import { ICityViewModel, StateViewModel } from 'src/app/service/state.model';
import { IAirportCodeList, IGetLocationViewModel } from 'src/app/service/vehicle.model';
import { VendorService } from 'src/app/service/vendor.service';
import { NOTIFICATION_WARNING_TIME } from 'src/app/shared/properties/application.properties';
import { AddressTypeEnum } from '@enums/address-type.enum';

declare var $;

@Component({
  selector: 'app-create-location-dialog',
  templateUrl: './create-location-dialog.component.html',
  styleUrls: ['./create-location-dialog.component.css'],
})
export class CreateLocationDialogComponent implements OnInit {
  private _subscriptions: Subscription = new Subscription();
  AddressType: string[] = AddressType;
  cityList: ICityViewModel[] = [];
  countryList: ICountryList[] = [];
  stateListForMember: StateViewModel[] = [];
  airportCodeList: IAirportCodeList[] = [];
  searchedAddr: string;
  autoCompleteAddrInput: HTMLInputElement;
  stateList: StateViewModel[];
  airport: string;
  isCityButtonShow = false;
  isShowAddCity = false;
  stateId: any;
  createLocationButtonLoader: boolean = false;
  public isShowAddAirportCode: boolean = false;
  Location: CreateLocation = {
    customerId: '',
    addressName: '',
    countryId: '',
    stateId: '',
    cityId: '',
    streetAddress: '',
    zipcode: '',
    latitude: '',
    longitude: '',
    addressType: '',
    isGlobal: true,
    businessUnitId: null,
    LocationAddressType: null,
    airportCode: null,
  };
  cityAdd: ICityViewModel = {
    cityId: DefaultGUID,
    id: DefaultGUID,
    cityName: '',
    cityCode: '',
    stateId: DefaultGUID,
  };

  constructor(
    private _memberService: MemberService,
    private _toastr: ToastrService,
    private _vendorService: VendorService,
    private _locationService: LocationService,
    private _dialogRef: MatDialogRef<CreateLocationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _dialogData: { customerBusinessunitId: string; locationList: IGetLocationViewModel[] },
  ) {}

  ngOnInit(): void {
    this.getCountryList();
    this.getStateList();
    this.getAllAirportCodeList();
    if (this._dialogData.locationList) {
      this._dialogData.locationList.forEach((x) => (x.address = x.streetAddress + ', ' + x.city + ', ' + x.state + ', ' + x.zipCode));
    }
  }
  getCountryList() {
    this._subscriptions.add(
      this._memberService.getCountryList().subscribe((response) => {
        this.countryList = response;
      }),
    );
  }
  getStateList() {
    this._subscriptions.add(
      this._vendorService.getStateList().subscribe((response) => {
        this.stateListForMember = response;
        this.stateList = response;
      }),
    );
  }
  clearLocationData() {
    this.Location = {
      customerId: '',
      addressName: '',
      countryId: '',
      stateId: '',
      cityId: '',
      streetAddress: '',
      zipcode: '',
      latitude: '',
      longitude: '',
      addressType: '',
      isGlobal: true,
      businessUnitId: null,
      LocationAddressType: null,
      airportCode: null,
    };
    this.clearCityData();
  }
  clearCityData() {
    this.cityAdd = {
      cityId: DefaultGUID,
      id: DefaultGUID,
      cityName: '',
      cityCode: '',
      stateId: DefaultGUID,
    };
  }
  resetLocationForm(addLocationForm: any) {
    addLocationForm.resetForm();
    this._dialogRef.close(null);
  }
  autoSearchAddress() {
    let autocomplete: any;
    try {
      const options = {
        componentRestrictions: { country: EnabledCountryCodes },
        fields: ['address_component', 'adr_address', 'business_status', 'formatted_address'],
      } as google.maps.places.AutocompleteOptions;
      this.autoCompleteAddrInput = document.getElementById('reusableAutocompleteAddress') as HTMLInputElement;
      autocomplete = new google.maps.places.Autocomplete(this.autoCompleteAddrInput, options);
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        var place = autocomplete.getPlace();
        this.Location.addressName = $('#reusableAutocompleteAddress').val().split(',')[0];
        if (place != null && place['adr_address'] != null) {
          this.autoSelectAddress(place['adr_address'], place['address_components']);
        }
      });
    } catch (error) {
      this._toastr.warning('Unable to fetch address! Please try again.', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
    }
  }
  autoSelectAddress(str, formatted_address: any[]) {
    this.clearLocationAddressData();
    const htmlAddr = str;
    const parser = new DOMParser();
    const parsedData = parser.parseFromString(htmlAddr, 'text/html');
    const arr = parsedData.getElementsByTagName('span');
    this.Location.streetAddress = this.returnStreetAddress(parsedData);
    this.Location.zipcode = this.returnZipCode(parsedData);
    const stateCode = this.returnStateCode(parsedData);
    const cityName =
      parsedData.getElementsByClassName('locality').length > 0 ? parsedData.getElementsByClassName('locality')[0].innerHTML : null;
    const currState = this.stateList.find((x) => x.stateCode == stateCode);
    if (currState != null || currState != undefined) {
      this.Location.stateId = currState.stateId;
      this.getAndSetCityByStateId(currState, cityName);
    } else {
      for (let i = 0; i < formatted_address.length; i++) {
        if (formatted_address[i]['types'][0] == 'administrative_area_level_1' || formatted_address[i]['types'][0] == 'locality') {
          const city = this.cityList ? this.cityList.find((x) => x.cityName == formatted_address[i]['long_name']) : null;
          if (city != null || city != undefined) {
            this.Location.cityId = city.cityId;
          } else {
            this.cityAdd.cityName = formatted_address[i]['long_name'];
            const state = this.stateList.find((x) => x.stateName == formatted_address[i]['long_name']);
            if (state != null || state != undefined) {
              this.Location.stateId = state.stateId;
              this.getAndSetCityByStateId(state, cityName);
            }
          }
        }

        if (formatted_address[i]['types'][0] == 'country') {
          const country = this.countryList.find((x) => x.countryName == formatted_address[i]['long_name']);
          if (country != null || country != undefined) this.Location.countryId = country.countryId;
          if (formatted_address[i]['long_name'] == 'Puerto Rico' || formatted_address[i]['long_name'] == 'United States') {
            const state = this.stateList.find((x) => x.stateName == formatted_address[i]['long_name']);
            if (state != null || state != undefined) {
              this.Location.stateId = state.stateId;
              this.getAndSetCityByStateId(state, cityName);
            }
          }
        }
        if (formatted_address[i]['types'][0] == 'postal_code') {
          this.Location.zipcode = formatted_address[i]['long_name'];
        }
      }
    }
  }
  private getAndSetCityByStateId(currState: StateViewModel, cityName: string) {
    this._subscriptions.add(
      this._vendorService.getCityByState(currState.stateId).subscribe((response) => {
        this.cityList = response;
        const currCity = this.cityList.find((city) => city.cityName == cityName);
        if (currCity == null || currCity == undefined) {
          this.cityAdd.cityName = cityName;
          this.addCity();
        } else {
          this.Location.cityId = currCity.cityId;
        }
      }),
    );
  }

  private returnStreetAddress(parsedData: Document): string {
    const streetAddr: string =
      parsedData.getElementsByClassName('street-address').length > 0
        ? parsedData.getElementsByClassName('street-address')[0].innerHTML
        : '';
    return streetAddr;
  }
  private returnZipCode(parsedData: Document): string {
    const zipCode: string =
      parsedData.getElementsByClassName('postal-code').length > 0
        ? parsedData.getElementsByClassName('postal-code')[0].innerHTML.substring(0, 5)
        : '';
    if (zipCode.length != 0 && zipCode.includes(' ')) return zipCode.substring(0, 3);
    else return zipCode;
  }
  private returnStateCode(parsedData: Document): string {
    const stateCode =
      parsedData.getElementsByClassName('region').length > 0 ? parsedData.getElementsByClassName('region')[0].innerHTML : null;
    return stateCode;
  }
  private clearLocationAddressData(): void {
    this.Location.streetAddress = '';
    this.Location.stateId = '';
    this.Location.cityId = '';
    this.Location.zipcode = '';
  }
  getCityByState(event, flag?) {
    this.isCityButtonShow = true;
    this.stateId = event;
    this._subscriptions.add(
      this._vendorService.getCityByState(this.stateId).subscribe((response) => {
        this.cityList = response;
        const city = this.cityList.find((x) => x.cityId == flag);
        if (this.cityList.length > 0 && flag != undefined && city != null && city != undefined) {
          this.Location.cityId = city.cityId;
        }
      }),
    );
  }
  addCity() {
    if (this.cityAdd.cityName != '') {
      this.cityAdd.stateId = this.Location.stateId;
      this._memberService.addCity(this.cityAdd).subscribe(
        (response) => {
          this.getCityByState(this.Location.stateId, response);
          this.isShowAddCity = false;
          this.clearCityData();
        },
        (error) => {
          console.log(error);
          this._toastr.warning('Something went wrong! Please try again', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
        },
      );
    } else {
      this.isShowAddCity = false;
      this.clearCityData();
    }
  }
  getAllAirportCodeList() {
    if (this._locationService.airportCodeList$.value.length > 0) {
      this.airportCodeList = this._locationService.airportCodeList$.value;
    } else {
      this._subscriptions.add(
        this._locationService.getAllAirportCodeList().subscribe((response) => {
          this.airportCodeList = response;
        }),
      );
    }
  }
  addAirportCode() {
    if (this.airport && this.airport.trim().length >= 3) {
      this.isShowAddAirportCode = false;
      this.airportCodeList.every((airport) => airport.airportCode != this.airport.toUpperCase())
        ? this.airportCodeList.push({
            addressId: DefaultGUID,
            airportCode: this.airport.toUpperCase(),
            airportName: this.Location.addressName.trim(),
          })
        : null;
      this.Location.airportCode = this.airport.toUpperCase();
      this.airport = '';
    }
  }
  addLocation(addLocationForm: any) {
    if (addLocationForm.valid) {
      let country: ICountryList;
      try {
        this.Location.businessUnitId = this._dialogData.customerBusinessunitId;
        this.Location.customerId = this._dialogData.customerBusinessunitId;
        this.clearCityData();
        this.createLocationButtonLoader = true;
        const cityName = this.cityList.find((city) => city.cityId == this.Location.cityId);
        const state = this.stateList.find((state) => state.stateId == this.Location.stateId);
        if (state != null) {
          country = this.countryList.find((country) => country.countryId == state.countryId);
          this.Location.countryId = country.countryId;
        } else {
          country = this.countryList.find((country) => country.countryName == 'USA');
          this.Location.countryId = country.countryId;
        }
        this.Location.addressType = 'CustomerAddress';
        const countryName = country.countryName ?? 'USA';
        const address = `${this.Location.addressName}, ${this.Location.streetAddress}, ${cityName.cityName}, ${state.stateName} ${countryName} ${this.Location.zipcode}`;
        /**
         * @var selectedLocation is used to check if the selected location is exist or not (if not exist then create one else return the selected location)
         * @callback (location) is used to match the address
         */
        const addressToBeAdded = `${this.Location.streetAddress}, ${cityName.cityName}, ${state.stateName}, ${this.Location.zipcode}`;
        const selectedLocation = this._dialogData.locationList.find(
          (location) =>
            (location.isGlobal && this.Location.isGlobal && location.address.includes(addressToBeAdded)) ||
            (!location.isGlobal &&
              !this.Location.isGlobal &&
              location.businessUnitId == this.Location.customerId &&
              location.address.includes(addressToBeAdded)),
        );
        if (selectedLocation == undefined) {
          const geocoder = new google.maps.Geocoder();
          const _this = this;
          geocoder.geocode(
            {
              address: address,
            },
            function (results, status) {
              if (status == 'OK') {
                const longitude = results[0].geometry.location.lng();
                const latitude = results[0].geometry.location.lat();
                if (longitude && latitude) {
                  _this.Location.latitude = latitude.toString();
                  _this.Location.longitude = longitude.toString();
                  _this.createLocation(_this.Location);
                } else {
                  _this.createLocationButtonLoader = false;
                }
              } else {
                _this.createLocationButtonLoader = false;
                _this.clearLocationData();
                _this.resetLocationForm(addLocationForm);
                _this._toastr.error('Location not found! Please check your address.', 'Error', {
                  timeOut: 6000,
                  positionClass: 'toast-top-center',
                });
              }
            },
          );
        } else {
          const createLocationResponseModel = this.getCreateLocationResponse(true, selectedLocation);
          this._dialogRef.close(createLocationResponseModel);
        }
      } catch (error) {
        this.createLocationButtonLoader = false;
        this._toastr.error('Unable to create location! Please try again.', 'Error', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      }
    }
  }

  createLocation(locationData: CreateLocation) {
    this._memberService.addLocation(locationData).subscribe(
      (response) => {
        const addressResponse = this.getCreateLocationResponse(false, response);
        this._locationService.serviceLocationList$.value.push(addressResponse.newAddress);
        const newAddressAirportCode: IAirportCodeList = this.airportCodeList.find((airport) => airport.addressId == DefaultGUID);
        if (newAddressAirportCode) {
          newAddressAirportCode.addressId = addressResponse.newAddress.addressId;
          this._locationService.airportCodeList$.next(this.airportCodeList.sort());
        }
        this._dialogRef.close(addressResponse);
      },
      (err) => {
        this.createLocationButtonLoader = false;
        if (err?.error?.message == 'Address already exist') {
          this._toastr.warning(err.error.message, 'Warning', { timeOut: NOTIFICATION_WARNING_TIME, positionClass: 'toast-top-center' });
        } else {
          this._toastr.warning('Something went wrong! Please try again', 'Warning', {
            timeOut: NOTIFICATION_WARNING_TIME,
            positionClass: 'toast-top-center',
          });
        }
      },
    );
  }

  getCreateLocationResponse(isAddressAlreadyPresent: boolean, address: IGetLocationViewModel): ICreateLocationResponseModel {
    const createLocationResponseModel: ICreateLocationResponseModel = {
      isAddressAlreadyPresent: isAddressAlreadyPresent,
      newAddress: address,
      addressType: this.getAddressType(address),
    };

    return createLocationResponseModel;
  }

  private getAddressType(address: IGetLocationViewModel): AddressTypeEnum {
    if (address.airportCode) {
      return AddressTypeEnum.Airport;
    } else if (!address.isGlobal) {
      return AddressTypeEnum.Private;
    }

    return AddressTypeEnum.Public;
  }
}
